import React, {useState, useEffect, useContext} from 'react';
import {AuthContext} from "../login/FirebaseAuth"
import { useSharedState } from '../store';
import { useNavigate } from 'react-router-dom';
import FormTemplate from './FormTemplate';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import {serverPost} from '../services/serverPost'
import {serverFetchData} from '../services/serverFetch'
import { getAuth, onAuthStateChanged} from 'firebase/auth';
import {REGIONS, REGIONS_BY_COUNTRY, EDITOR_TYPE} from '../services/const'
import AddPhotoSingle from '../camera/AddPhotoSingle'
const MAX_DESC_LENGTH = 40000


const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

const styles={
    container:{
        paddingTop:30,
        /*
        display: 'flex',
        flexDirection:'column',
        maxWidth:'100%',   
        alignItems:'center'
        */
       color:'black'
    },
  }

const fields = [
    {
        type:'text',
        label:'Nickname (if this is filled in, your real name is hidden on page)',
        name:'nickname',
        maxlength:100,
    },
    {
        type:'text',
        label:'First Name',
        name:'firstName',
        required:true,
        maxlength:100,
    },
    {
        type:'text',
        label:'Last Name',
        name:'lastName',
        required:true,
        maxlength:100,
    },
    /*
    {
        type:'email',
        label:'E-mail',
        name:'email',
        required:true
    },
    */
    {
        type:'text',
        label:'Phone',
        name:'phone',
        maxlength:16,
    },
    {
        type:'text',
        label:'City:',
        name:'city',
        required:true,
        tooltip:'Events with same city is show in same calendar for that city',
        placeholder:'Please enter your city',
        maxlength:80,
    },
    {
        type:'select',
        label:'Region',
        name:'region',
        radioValues:REGIONS,
        selectValues:REGIONS,
        selectValuesFunc:country=>REGIONS_BY_COUNTRY[country?country:'Sverige'],
        required:true,
        tooltip:'Events with same region is show in same calendar for that region',
        maxlength:80,

    },    
    {
        type:'checkbox',
        label:'Active',
        name:'active',
        tooltip: 'Checked if the DJ is active and want to be shown on the WEB-page'
    },
    {
        type:'comment',
        label:'Image of DJ',
        name:'profileImage',
        maxlength:100,
    },
    {
        type:'checkbox',
        label:'HTML-editor',
        name:'htmlEditor',
        tooltip: 'Event enddate defaults to same as startdate',
        maxlength:10,
    },
    {
        // type:'rte',
        type:EDITOR_TYPE.ACTIVE,
        label:'Description of DJ',
        name:'description',
        draftName:'draft_description',
        required:false,
        hiddenIf:'htmlEditor',
        maxlength:200,
    },
    {
        type:'textarea',
        label:'Description of DJ (in HTML)',
        name:'description',
        required:false,
        notHiddenIf:'htmlEditor',
        maxlength:40000,
    },
]

const Func = () => {
    const [sharedState, ] = useSharedState()
    const [value, setValue] = useState()
    const [list, setList] = useState([])
    const navigate = useNavigate()
    const {user} = useContext(AuthContext)
    const signinEmail = user?user.email?user.email:undefined:undefined
    const subdir = process.env.REACT_APP_IMAGES_USER_DIR


    // useEffect(()=>setValue(props.init),[props.init])
    const handleReplyDj = reply => {

        if (reply?reply.status === 'OK':false) {
            if (reply.result) {
                setValue(reply.result)
            } else {
                console.log('[EditDj.js] No current info about DJ') 
            }    
        } else {
            setValue({})
            console.log('Currently no info regarding DJ')
        }
    }


    useEffect(()=>{
        if (signinEmail) {
                // Get DJ for the email of the logged in user
                const irl1 = '/getDj?email=' + signinEmail
                serverFetchData(irl1, handleReplyDj)
            } 
    }, [])

    const deleteRow = index => setList(list.filter((it, idx)=>idx !== index))  

    const handleCancel = () => {
        navigate('/calendar/' + sharedState.region)
    }

    const handleReset = () => {
        setValue({})
    }

    const handleSaveReply = result => {
        if (result.status === 'OK') {
          console.log('Description saved on disk')  
        } else {
          if (result.message) {
            alert(JSON.stringify(result.message))  
          }  
          console.log('ERROR:Save DJ failed')  
        }
    }
  
    const handleSave = () => {
        if (!!signinEmail) {
            const active = value.active == 1?1:0
            const data = {...value, active, email:signinEmail, authLevel:undefined, html:undefined, draft_description:undefined, creaTimestamp:undefined, updTimestamp:undefined}
            const record = {table:'tbl_dj', data, fetchRows:true}
            if (value.description?value.description.length > MAX_DESC_LENGTH:false) {
                alert('WARNING: Application doew not does not allow to save text longer than ' + MAX_DESC_LENGTH + ' characthers')
            } else {
                serverPost('/replaceRow', record, handleSaveReply)
            }    
        } else {
            alert('No valid email when saving')
        }   
    }

    const handleSaveImage = (profileImage, result) => {
        if (result.status === 'OK') {
            const row = result.list.find(it=>it.email === signinEmail)
            if (row) {
                console.log('Image ' + profileImage + ' saved to disk')  
                setTimeout(()=>{
                    URL.revokeObjectURL(profileImage)
                    window.location.reload(false);
                }, 
                2000);
        
            } else {
                setValue({...row, profileImage:undefined})
                console.log('[EditDisckjockey] Image not found in list')  
            }
          } else {
            if (result.message) {
              alert(JSON.stringify(result.message))  
            }  
            console.log('ERROR:Save DJ failed')  
        }
  
    }

    const setProfileImage = fname => {
        if (fname) {
            const profileImage = apiBaseUrl + subdir + '/' + fname
            const active = value.active == 1?1:0
            const data = {...value, active, email:signinEmail, profileImage, html:undefined, draft_description:undefined, creaTimestamp:undefined, updTimestamp:undefined}
            const record = {table:'tbl_dj', data, fetchRows:true}
            setValue({...value, profileImage})
            serverPost('/replaceRow', record, result=>handleSaveImage(profileImage, result))
        } else {
            alert("ERROR: Image not loaded")
        }
    }    

    const buttons=[
        {
            type:'button',
            label:'Save',
            validate:true,
            handleClick:handleSave
        },    
        {
            type:'button',
            label:'Undo',
            handleClick:handleReset
        },    
        {
            type:'button',
            label:'Cancel',
            onClick:handleCancel
        },    
    ]

    return(
        <div style={styles.container}>
            {value?
                <>
                    <h3 style={{textAlign:'center'}}>If you are a TDJ, please enter your data</h3>
                    <div className='columns m-6 is-center'>
                        <div className='column is-8'>
                            <FormTemplate 
                                        fields={fields} 
                                        value={value}
                                        setValue={setValue}
                                        setList={setList}
                                        buttons={buttons}
                            />
                        </div>
                        <div className='column is-4'>

                            <img src={value.profileImage?value.profileImage:''} alt={'Missing image:' + value.profileImage}/>
                            {signinEmail?<AddPhotoSingle 
                                remove={true}
                                filename={signinEmail} 
                                matching={signinEmail} 
                                subdir={subdir}
                                list={list} 
                                setProfileImage={setProfileImage} />
                            :null}  
                            <p/>
                        </div> 
                    </div>    
                </>
            :
                <div className='content' style={{textAlign:'center', margin:'auto'}}>
                    <h4>Please signup/signin to add/edit your TDJ info</h4>
                    <h4>If you want access to add/update events in calendar, please contact Per Gustav Eskilson at <a href="mailto:paelsis@hotmail.com">paelsis@hotmail.com</a></h4>
                </div>
            }    
        </div>
    )
        
}

export default Func

